import React from "react";
import TableHeader from "./TableHeader";
import TableBody from "./TableBody";
import styled from "styled-components";
import TablePagination from "./TablePagination";

export default function Table({
  thead = [],
  tbody = [],
  action = <></>,
  currentPage = 1,
  setCurrentPage = () => {},
  totalPage = 0
}) {
  return (
    <TableContainer className="table-responsive">
      <table className="table">
        <TableHeader thead={thead} />
        <TableBody tbody={tbody} thead={thead} action={action} />
      </table>
      <TablePagination
        totalPage={totalPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </TableContainer>
  );
}

const TableContainer = styled.div`
  font-size: 0.8rem;
`;
